import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import check from "../../assets/svgs/single-check.svg";
import "./PaymentMethod.css";
import stripeLogo from "../../assets/images/stripe_logo.png";
import warelyPayLogo from "../../assets/images/warely_pay_icon.png";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

// Rapyd is intentionally not listed: it stays hidden/disabled.
export const GATEWAY_OPTIONS = [
  {
    id: 1,
    key: "Stripe",
    label: "Stripe",
    description: "Credit / Debit Card - Visa, Mastercard, Amex & more",
    logo: stripeLogo,
  },
  {
    id: 2,
    key: "Airwallex",
    label: "Warely Pay",
    description: "Pay securely with Warely Pay",
    logo: warelyPayLogo,
  },
  {
    id: 3,
    key: "HitPay",
    label: "HitPay",
    description: "PayNow, cards & more with HitPay",
    logo: null, // no HitPay logo asset yet, falls back to a letter badge
  },
];

const GatewaySelect = ({ show, onClose, onProceed, submitting }) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (show) setSelected(null);
  }, [show]);

  const handleProceed = () => {
    if (!selected || submitting) return;
    onProceed(selected);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="pm-modal"
      dialogClassName="pm-dialog"
      contentClassName="pm-content"
      centered
      backdrop="static"
    >
      <div className="pm-header">
        <div className="pm-header-left">
          <div className="pm-header-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
              <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
          </div>
          <div>
            <h5 className="pm-title">Payment Method</h5>
            <p className="pm-subtitle">Choose how you'd like to pay</p>
          </div>
        </div>
        <ModalCloseButton
          onClick={onClose}
          style={{ position: "static", width: "32px", height: "32px" }}
        />
      </div>

      <Modal.Body className="pm-body">
        <div className="pm-options">
          {GATEWAY_OPTIONS.map((option) => {
            const isActive = selected === option.key;
            return (
              <button
                key={option.id}
                className={`pm-option${isActive ? " pm-option--active" : ""}`}
                onClick={() => setSelected(option.key)}
                disabled={submitting}
              >
                <div className="pm-option-icon pm-option-icon--logo">
                  {option.logo ? (
                    <img src={option.logo} alt={option.label} />
                  ) : (
                    <span className="pm-option-logo-fallback">{option.label.charAt(0)}</span>
                  )}
                </div>
                <div className="pm-option-text">
                  <span className="pm-option-label">{option.label}</span>
                  <span className="pm-option-desc">{option.description}</span>
                </div>
                <div className={`pm-option-check${isActive ? " pm-option-check--active" : ""}`}>
                  {isActive && <img src={check} alt="selected" className="pm-check-img" />}
                </div>
              </button>
            );
          })}
        </div>

        {selected && (
          <div className="pm-summary">
            <span className="pm-summary-label">Selected:</span>
            <span className="pm-summary-value">
              {GATEWAY_OPTIONS.find((o) => o.key === selected)?.label}
            </span>
          </div>
        )}
      </Modal.Body>

      <div className="pm-footer">
        <button className="pm-cancel-btn" onClick={onClose} disabled={submitting}>
          Cancel
        </button>
        <button
          className={`pm-proceed-btn${!selected || submitting ? " pm-proceed-btn--disabled" : ""}`}
          onClick={handleProceed}
          disabled={!selected || submitting}
        >
          {submitting ? "Processing..." : "Proceed"}
          {!submitting && (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          )}
        </button>
      </div>
    </Modal>
  );
};

export default GatewaySelect;
